import type { NavItemConfig } from '../../types/nav';
import { paths } from '../../paths';

export interface LayoutConfig {
  navItems: NavItemConfig[];
}

export interface PartnerLayoutConfig {
  navItems: NavItemConfig[];
}

export const layoutConfig = {
  navItems: [
    {
      key: 'dashboards',
      title: 'MY OPTIMA',
      items: [
        // { key: 'overview', title: 'Home', href: paths.dashboard.overview, icon: 'house' },
        { key: 'taxPreparation', title: 'Tax Preparation', href: paths.dashboard.taxPreparation, icon: 'taxPreparation' },
        { key: 'taxShield', title: 'Tax Shield', href: paths.dashboard.taxShield.reports, icon: 'shield', isProtected: 'FREE', label: 'FREE'},
        { key: 'taxShield', title: 'Tax Shield', href: paths.dashboard.taxShield.enrollment, icon: 'shield', isProtected: 'NO'},
        { key: 'taxShield', title: 'Tax Shield', icon: 'shield', isProtected: 'PRO', label: 'PRO', items: [
          {key: 'taxShieldOverview', title: 'Overview', href: paths.dashboard.taxShield.overview},
          // {key: 'taxShieldMessages', title: 'Messages', href: paths.dashboard.taxShield.messages.list('inbox')},
          {key: 'taxShieldDocuments', title: 'Documents', href: paths.dashboard.taxShield.documents},
          {key: 'taxShieldReports', title: 'Reports', href: paths.dashboard.taxShield.reports}
        ] },
        { key: 'taxShield', title: 'Tax Shield', icon: 'shield', isProtected: 'PTR', label: 'PTR', items: [
            { key: 'taxShieldOverview', title: 'Overview', href: paths.dashboard.taxShield.overview },
            { key: 'taxShieldDocuments', title: 'Documents', href: paths.dashboard.taxShield.documents },
            { key: 'taxShieldReports', title: 'Reports', href: paths.dashboard.taxShield.reports }
          ] },
        // { key: 'taxRelief', title: 'Tax Relief', href: paths.dashboard.taxRelief, icon: 'taxRelief' },
        { key: 'noticeAnalyzer', title: 'Notice Analyzer', href: paths.dashboard.noticeAnalyzer, icon: 'noticeAnalyzer' },
      ],
    },
    {
      key: 'settings',
      title: 'SETTINGS',
      showAtBottom: true,
      items: [
        { key: 'upgrade', title: 'Upgrade Today', href: paths.settings.upgrade, isProtected: 'FREE', icon: 'upgrade' },
        { key: 'myaccount', title: 'My Account', icon: 'myaccount', items: [
          {key: 'profile', title: 'Profile', href: paths.settings.myaccount.profile},
          {key: 'security', title: 'Password & Security', href: paths.settings.myaccount.security},
          {key: 'paymentMethods', title: 'Billing', href: paths.settings.myaccount.paymentMethods},
          {key: 'notifications', title: 'Notifications', href: paths.settings.myaccount.notifications}
        ] },
        { key: 'getHelp', title: 'Get Help', href: paths.settings.getHelp, icon: 'getHelp' },
        { key: 'clientPortal', title: 'Client Portal', href: paths.settings.clientPortal, icon: 'clientPortal' },
        { key: 'signOut', title: 'Sign Out', href: paths.settings.signOut, icon: 'signOut' },
      ],
    }
  ],
} satisfies LayoutConfig;


export const partnerLayoutConfig = {
  navItems: [
    {
      key: 'dashboards',
      title: 'MY OPTIMA',
      items: [
        { key: 'overview', title: 'Home', href: paths.partner.dashboard.overview, icon: 'house' },
        { key: 'myReferrals', title: 'My Referrals', href: paths.partner.dashboard.myReferrals, icon: 'myReferrals'},
        // { key: 'myJobs', title: 'My Jobs', icon: 'myJobs', items: [
        //   {key: 'newJobs', title: 'New', href: paths.partner.dashboard.myJobs.newJobs},
        //   {key: 'acceptedJobs', title: 'Accepted', href: paths.partner.dashboard.myJobs.acceptedJobs},
        //   {key: 'declinedJobs', title: 'Declined', href: paths.partner.dashboard.myJobs.declinedJobs},
        // ] },
        // { key: 'myPartners', title: 'My Partners', href: paths.partner.dashboard.myPartners, icon: 'myPartners' },
      ],
    },
    {
      key: 'settings',
      title: 'SETTINGS',
      showAtBottom: true,
      items: [
        { key: 'myaccount', title: 'Account', icon: 'myaccount', items: [
          {key: 'profile', title: 'Profile', href: paths.partner.settings.myaccount.profile},
          {key: 'licensesInsurance', title: 'Licenses & Insurance', href: paths.partner.settings.myaccount.licensesInsurance},
          {key: 'passwordReset', title: 'Password Reset', href: paths.partner.settings.myaccount.passwordReset},
          {key: 'notifications', title: 'Notifications', href: paths.partner.settings.myaccount.notifications},
          {key: 'sharingQRcode', title: 'Easy Sharing URL & QR code', href: paths.partner.settings.myaccount.sharingQRcode},
        ]},
        // { key: 'getHelp', title: 'Get Help', href: paths.partner.settings.getHelp, icon: 'getHelp' },
        { key: 'signOut', title: 'Sign Out', href: paths.partner.settings.signOut, icon: 'signOut' },
      ],
    }
  ],
} satisfies PartnerLayoutConfig;